import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { BackofficeRestQueries } from "@/api/backofficeRest/queries"
import {
  FeatureFlagChangeListResponse,
  FeatureFlagListResponse,
} from "@/api/backofficeRest/generated/model"
import { FeatureParser } from "@/models/admin/feature/feature.parser"
import { IFeature } from "@/models/admin/feature/feature.types"
import { parseFeatureChanges } from "@/models/admin/featureChange/featureChange.parser"
import { IFeatureChange } from "@/models/admin/featureChange/featureChange.types"

class FeaturesServiceClass {
  getFeaturesAdminList(): QueryResult<IFeature[]> {
    return useQuery<FeatureFlagListResponse, IFeature[]>({
      ...BackofficeRestQueries.featureFlags.list(),
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data) =>
        data.featureFlags.map((f) => FeatureParser.toDomain(f)),
    })
  }

  /**
   * One flag's history, or changes across all flags when featureId is null.
   * currentFeatures gives the state after each flag's latest change.
   */
  getFeatureChanges(
    featureId: number | null,
    currentFeatures: IFeature[],
  ): QueryResult<IFeatureChange[]> {
    return useQuery<FeatureFlagChangeListResponse, IFeatureChange[]>({
      ...BackofficeRestQueries.featureFlags.changes(featureId),
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data) => parseFeatureChanges(data, currentFeatures),
    })
  }

  isFeatureActive(featureName: string): boolean | undefined {
    const list = FeaturesService.getFeaturesAdminList()
    if (list.isFetching) return undefined

    return !!list.data.find((feature) => featureName === feature.name)?.enabled
  }
}

export const FeaturesService = new FeaturesServiceClass()
